var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.href ? _c('a', _vm._b({
    staticClass: "button-text",
    class: _vm.$style.linkAnchor,
    attrs: {
      "href": _vm.href,
      "target": _vm.target
    }
  }, 'a', _vm.$attrs, false), [_vm._t("default")], 2) : _vm.to ? _c('RouterLink', _vm._b({
    staticClass: "button-text",
    class: _vm.$style.linkAnchor,
    attrs: {
      "to": _vm.routerLinkTo
    }
  }, 'RouterLink', _vm.$attrs, false), [_vm._t("default")], 2) : _c('span', {
    class: _vm.$style.noLink
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }